module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/childcare-mobile@3x-4e993c24e0b94b7837ad51f0c4795bb7.jpg";